import {IFormSubmissionStatus, IFormSubmissionStatusSummary} from "../../../common/interfaces/formSubmissionInterfaces";
import {ArrayHelper} from "../../../common/helpers/arrayHelper";
import Datetimeable from "../../../common/mixins/datetimeable";
import {StatusGroupType} from "../enums/statusGroupType";
import DocumentDecorator from "./documentDecorator";
import SubmissionDecorator from "./submissionDecorator";

export default class FormDecorator extends DocumentDecorator {
  title: string;
  published_form_ids: string[];
  published_form: { id: string };
  last_complete_submissions_count: number;
  last_incomplete_submissions_count: number;
  statusSummary: IFormSubmissionStatusSummary = {
    complete_submissions_count: 0,
    incomplete_submissions_count: 0,
    statuses: []
  };
  publishedForms: Array<{ c_at: string, id: string, version_name: string }> = [];
  submissions: SubmissionDecorator[] = [];
  submissionsFullyLoaded: boolean;

  static get displayName(): string {
    return 'FormDecorator';
  }

  constructor(obj: object = {}) {
    super(obj);
    this.setPropertyDefaults();
  }

  get isPublished(): boolean {
    return !!this.published_form;
  }

  get stepStatusSummary(): Array<IFormSubmissionStatus> {
    return this.statusSummary.statuses
        .map(s => {
          return {
            name: s.name,
            count: s.count,
            displayName: s.name,
            is_workflow_step: s.is_workflow_step
          };
        });
  }

  get statusSummaryForListView(): Array<{ name: string, displayName: string }> {
    const summary: { name: string, displayName: string }[] = this.stepStatusSummary.slice();
    summary.unshift(
      {name: "", displayName: StatusGroupType.all},
      {name: StatusGroupType.complete, displayName: StatusGroupType.complete},
      {name: StatusGroupType.incomplete, displayName: StatusGroupType.incomplete}
    );
    return summary;
  }

  isStepStatus(status: string): boolean {
    return this.stepStatusSummary.some(summary => summary.displayName === status);
  }

  get publishedFormsSorted() {
    return ArrayHelper.sortByDate(this.publishedForms.concat(), 'c_at');
  }

  get publishedFormsForView() {
    if (this.publishedForms.length <= 0) {
      return this.publishedForms;
    }

    const forms = this.publishedFormsSorted
        .map(f => {
          return {
            id: f.id,
            displayName: f.version_name,
            c_at: f.c_at
          };
        });
    forms[0].displayName = 'Latest Version';
    return forms;
  }

  setPropertyDefaults() {
    const defaults = {
      published_form_ids: [],
      last_complete_submissions_count: 0,
      last_incomplete_submissions_count: 0,
      submissionsFullyLoaded: false
    };

    for (const key in defaults) {
      if (!this[key]) {
        this[key] = defaults[key];
      }
    }
  }
}